import * as appsInstaller from '@wix/auto_sdk_apps-installer_apps-installer';

export { appsInstaller };
